import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=05a3888b&scoped=true"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3888b",
  null
  
)

export default component.exports